import { utils } from '@pixi/core';

function checkExtension(url, extension) {
  const tempURL = url.split("?")[0];
  const ext = utils.path.extname(tempURL).toLowerCase();
  if (Array.isArray(extension)) {
    return extension.includes(ext.toLowerCase());
  }
  return ext.toLowerCase() === extension;
}

export { checkExtension };
//# sourceMappingURL=checkExtension.mjs.map
